import { CouponResponse, ServiceResponse } from '@bzbs/react-api-client';
import { create } from 'zustand';
import { useBuzzebeesAppStore } from './buzzebeess-app.store';
import { useLocaleStore } from './locale.store';

export type CouponState = {
  data: CouponResponse | null;
  isLoading: boolean;
  error: ServiceResponse<unknown> | null;
};

export type CouponActions = {
  processCodes: (codes: string[]) => Promise<ServiceResponse<CouponResponse>>;
  clear: () => void;
};

export type CouponStore = CouponState & CouponActions;

export const useCouponStore = create<CouponStore>((set) => ({
  data: null,
  isLoading: false,
  error: null,

  processCodes: async (codes: string[]) => {
    const bzbsService = useBuzzebeesAppStore.getState().bzbsService;
    if (!bzbsService) {
      return { type: 'client-error', message: 'Service not configured' };
    }

    set({ isLoading: true });
    const response = await bzbsService.couponApi.processCodes({ codes: codes.join(','), options: { device_locale: useLocaleStore.getState().localeId } });
    set({ isLoading: false });

    if (response.type === 'success') {
      set({
        data: response.model,
        error: null,
      });
    } else {
      set({ error: response });
    }

    return response;
  },

  clear: () => {
    set({
      data: null,
      isLoading: false,
      error: null,
    });
  },
}));
